import { Meta } from '../../Meta';
import { LOGGED_IN_APP_BASE_URL } from '../../../utils/url';
import { PostData } from '../utils';
import { BlogPostContent } from './Content';
import { MarketingPage } from '../../marketing/MarketingPage';

interface Props {
  postData: PostData;
}

export const BlogPost = ({ postData }: Props) => {
  return (
    <MarketingPage>
      <Meta title={`${postData.title}`}>
        <meta name="description" content={postData.description} />
        <meta name="author" content={postData.author.name} />
        <meta name="publish_date" property="og:publish_date" content={postData.date} />
        <meta property="og:title" content={`${postData.title}`} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={`${LOGGED_IN_APP_BASE_URL}/blog/${postData.slug}`} />
        <meta
          property="og:image"
          content={`${LOGGED_IN_APP_BASE_URL}/api/og?img=${encodeURIComponent(
            postData.featuredImage
          )}`}
        />
        <meta property="og:description" content={postData.description} />
        <meta name="twitter:label1" content="Time to Read" />
        <meta name="twitter:data1" content={`${postData.readingTime} minutes`} />
      </Meta>
      <BlogPostContent postData={postData} />
    </MarketingPage>
  );
};
